import React from 'react';
import { Icon } from './Icon';

interface CheckboxProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'size' | 'type'> {
  checked?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  label?: React.ReactNode;
  hint?: string;
  size?: 'sm' | 'md';
}

export const Checkbox: React.FC<CheckboxProps> = ({
  checked,
  onChange,
  label,
  hint,
  size = 'md',
  disabled,
  className = '',
  ...rest
}) => {
  const boxSize = size === 'sm' ? 'size-4' : 'size-5';
  const iconSize = size === 'sm' ? 12 : 14;

  return (
    <label
      className={[
        'inline-flex items-start gap-2.5 cursor-pointer select-none',
        disabled ? 'opacity-50 cursor-not-allowed' : '',
        className,
      ].join(' ')}
    >
      <span className="relative flex items-center justify-center flex-shrink-0 mt-0.5">
        <input
          type="checkbox"
          checked={checked}
          onChange={onChange}
          disabled={disabled}
          className="peer sr-only"
          {...rest}
        />
        <span
          className={[
            boxSize,
            'rounded-md border-2 transition-all',
            checked
              ? 'bg-primary border-primary'
              : 'border-slate-300 bg-white peer-hover:border-slate-400',
            'peer-focus-visible:ring-4 peer-focus-visible:ring-primary/20',
          ].join(' ')}
        />
        {checked && (
          <Icon
            name="check"
            size={iconSize}
            className="absolute text-white pointer-events-none"
          />
        )}
      </span>
      {(label || hint) && (
        <span className="flex-1 min-w-0">
          {label && <span className="text-sm text-slate-900 leading-tight">{label}</span>}
          {hint && <span className="block text-xs text-slate-500 mt-0.5">{hint}</span>}
        </span>
      )}
    </label>
  );
};
